shvenergy.compareenergysources = (function ($) {
	"use strict";

	function init() {

		var isAnimating = false;
		var allRows = $(".compare-resources-row");

		allRows.each(function() {

			var currentRow = $(this);

			var divider = currentRow.hasClass("centered") ? 1 : 2;

			var buts = []; //This will store buttons in active columns. We will need to trigger a click on page load on these

			function getCurrentRowWidth() {

				return parseInt(currentRow.width());

			}

			function setWidth() {
				var numberOfItems = currentRow.find("button").length;
				//console.log(numberOfItems);
				var width = (getCurrentRowWidth() - (80 * numberOfItems) + 80) / divider;
				currentRow.find(".comparegrid__item").not(".active").css({
					"width": "80px"
				});
				currentRow.find(".comparegrid__item.active").css("width", width + "px");
			}

			//This function runs once for each row in allRows
			function alignHeightsInSiblingColumnsIfCurrentRowIsNotCentered() {

				//No need to run this if there is only one centered column
				if (currentRow.hasClass("centered"))
					return;

				buts.forEach(function (el) {
					$(el).trigger("click");
					$(el).parent().removeClass("load");
				});
			}

			currentRow.find(".compare-resources-column").each(function () {
				var el = $(this);
				var buttons = el.find("button");
				var cols = el.find(".comparegrid__item");
				var activeButtonParent = el.find(".comparegrid__item.load");
				var but = activeButtonParent.find("button");
				buts.push(but); //we push the first button in each column where the parent has a class of load

				//Bind click handler to all buttons
				buttons.on("click", function (e) {
					e.stopPropagation();

					if (window.matchMedia("(min-width: 1024px)").matches) {

						var parent = $(this).parent();
						var siblingColumn = $(this).parents(".compare-resources-column").siblings()[0];
						
						//handle the active on first

						if (parent.hasClass("load")) {
							//do nothing, but allow for script further down to run
						} else {
							if (parent.hasClass("active") || isAnimating)
								return;
						}


						isAnimating = true;

						//get the text and clone it, so we can put it inside the current active container, measure its height and set the new height
						var textClone = parent.find(".comparegrid__item__text").clone();
						var siblingColumnActiveTextheight = $(siblingColumn).find(".comparegrid__item.active .comparegrid__item__text").outerHeight();

						textClone.css({
							"visibility": "hidden",
							"opacity": "0"
						}).addClass("textClone");
						textClone.appendTo(".comparegrid__item.active");
						var textCloneHeight = textClone.outerHeight();

						
						$(".textClone").remove();

						var maxHeights = [];
						maxHeights.push(textCloneHeight);
						maxHeights.push(siblingColumnActiveTextheight);

						var maxHeight = Math.max(...maxHeights);

						cols.find(".comparegrid__item__text.prepare-reveal").addClass("unreveal");

						setTimeout(function() {

							//unreveal class has been added
							cols.find(".comparegrid__item__text.prepare-reveal").removeClass("prepare-reveal unreveal reveal");
							cols.css("width", "80px").removeClass("active");
							parent.addClass("active");
							setWidth();
							currentRow.find(".comparegrid").css("min-height", maxHeight + 18 +"px");
							//new item has been set, now set show/reveal on text element
							setTimeout(function () {
								isAnimating = false;
								//this is also where we want to show the content of the item
								parent.find(".comparegrid__item__text").addClass("prepare-reveal");
								setTimeout(function () {
									parent.find(".comparegrid__item__text.prepare-reveal").addClass("reveal");
									
								}, 10);

							}, 410);

						}, 210);

					}
				});

			});

			setWidth();
			alignHeightsInSiblingColumnsIfCurrentRowIsNotCentered();

			$(window).on("resize", setWidth);
			

			$(".comparegrid").on('DOMNodeInserted', function (e) {
				setWidth();
			});

			$(".comparegrid").on('DOMNodeRemoved', function (e) {
				setTimeout(function () {
					setWidth();
				}, 100);

			});


		});

    }

    init();

})(jQuery);